export const MdMenuCleanerServiceModule = angular
    .module('app.services.utilities.mdMenuCleanerService', [])
    .service('mdMenuCleaner', ($mdUtil) => {
        return {
            clean
        };
        /**
        * We use `md-menu` everywhere in the app. Every time we open a md-menu
        * instance, two things happens: An element called `md-backdrop` is added
        * to the DOM and the scroll is disabled adding dom elements and other
        * techniques.
        *
        *`md-backdrop` basically prevents clicking on any element of the page,
        * expect for the menu itself. `md-backdrop` listens for clicks and closes
        * the menu if clicked anywhere outside of the opened menu.
        *
        * When you click either outside of the opened menu or in one of the menu
        * options, these two steps are reverted. This means that both the
        * `md-backdrop` and the actions applied to block the scroll are reverted.
        *
        * Before this fix, there was a bug related to these elements.
        * If you open a menu in the exact moment when the page is about to transition
        * to a new page and the menu is visible for a few ms in the screen, then in the
        * new page **you can’t scroll or click anything. All the UI is blocked by that
        * `md-backdrop` element and you can't scroll either**
        *
        * My theory for this behaviour is that the menu element is mounted too late
        * in the screen, possibly in the destroy phase of the parent component, so
        * the destroy events are not triggered again to perform a proper cleanup of
        * the menu state.
        *
        * If you open the menu too early, before the transition, the destroy phase
        * would happen correctly and the issue is not reproducible.
        *
        * This `clean` function tries to fix that, in a somewhat hacky way, by removing
        * the `md-backdrop` element and also, by calling the miraculously exposed
        * `_restoreScroll` function to unblock the scroll. However, if there are any
        * memory leaks related to the issue, this function won’t fix them.
        *
        * This function should only be called in the `$rootScope.$on('$stateChangeSuccess')`
        * event handler, so we perform the cleanup after we have made a transition from a
        * potentially dirty page.
        */
        function clean() {
            const menuBackdrop = angular.element('md-backdrop.md-menu-backdrop');
            if (menuBackdrop.length) {
                menuBackdrop.remove();
                $mdUtil.disableScrollAround._restoreScroll();
            }
        }
    }).name;


// WEBPACK FOOTER //
// ./src/app/services/utilities/mdMenuCleaner.service.js